module.exports = __webpack_public_path__ + "static/img/rppghealthapp1.b7c68e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthapp1.png
// module id = HHjp
// module chunks = 5